module.exports = __webpack_public_path__ + "img/logo_fsc.921818c8.jpeg";